
// Global Constants
export const LGTYPE_8B = "8B";
export const LGTYPE_9B = "9B";
export const LGTYPE_10B = "10B";

export const RESTYPE_ALL = "ALL";
export const RESTYPE_LEAGUE = "LEAGUE";
export const RESTYPE_TOURNAMENT = "TOURNAMENT";

// to use someday
export const ADMIN_LVL = {
	MASTER: 0,
	CHARTERS: 1,
	LEAGUES: 2,
	SEASONS: 3,
	ADMINLIMIT: 10,
	USER: 99,				// used everywhere
}

export const CUSTPUB_A = [
{
	custId: "LIBRE",
	custPdesc: "20231102 - Espace libre",
	custLink: "",
	custImg: "/img/pub_espace-libre-01a.png",
	altText: "espace-libre",
	dispRatioPct: 33,
	show: true
},
{
	custId: "SAPORA-01",
	custPdesc: "Sapora Pub",
	custLink: "https://savonssapora.etsy.com/",
	custImg: "/img/pub-sapora-01a.png",
	altText: "sapora",
	dispRatioPct: 33,
	show: true
},
{
	custId: "STATELO-01",
	custPdesc: "Statelo-Tour 01",
	custLink: "/tableau-de-bord",
	custImg: "/img/regulier-aut-2019.png",
	altText: "statelo-tour",
	dispRatioPct: 34,
	show: true
}
]

/*
{
	custId: "ET01",
	custPdesc: "20190415 - Fier partenaire",
	custLink: "https://www.viacapitalevendu.com/courtiers/tremblay-eric-5550",
	custImg: "/img/pub_eric-tremblay-01a.png",
	altText: "eric-tremblay",
	dispRatioPct: 70,
	show: true
},
{
	custId: "TB01",
	custPdesc: "1.00a - Annonce générale initiale",
	custLink: "https://tabillard.com",
	custImg: "/img/tb01a.png",
	altText: "tabillard",
	dispRatioPct: 0,
	show: false
},
*/